import React from "react";
import { Container, Col, ButtonGroup, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsCalculatorFill, BsPeopleFill, BsCreditCardFill } from "react-icons/bs";

// assets
import demoScreen from "./assets/img/demo-screen.mp4"
import { ReactComponent as Logo } from '../../assets/poker-ledger-logo.svg'

// styles
import './Landing.css'

export default function Landing() {
    return (
        <>
            <MastHead />
            <Features />
            <HowItWorks />
            <CallToAction />
        </>
    );
}

const MastHead = () =>
    <header className="masthead">
        <Container className="px-5">
            <Row className="gx-5 align-items-center">
                <Col lg={6}>
                    <div className="mb-5 mb-lg-0 text-center text-lg-start">
                        <Logo/>
                        <p className="lead fw-bold text-muted">Simplify Your Poker Game Management!</p>
                        <em className="text-muted mb-5">Effortlessly track buy-ins, cash-outs, and balances for every game.</em>
                    </div>
                    <ButtonGroup className="cta">
                        <Link to={"/sign-up"}><Button variant="success">Sign Up</Button></Link>
                        <a href="#how-it-works"><Button variant="secondary">See How It Works</Button></a>
                    </ButtonGroup>
                </Col>
                <Col lg={6}>
                    <DeviceMockup></DeviceMockup>
                </Col>
            </Row>
        </Container>
    </header>

const DeviceMockup = () =>
    <div className="device-mockup">
        <svg className="circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="circleGradient" gradientTransform="rotate(45)">
                    <stop className="gradient-start-color" offset="0%"></stop>
                    <stop className="gradient-end-color" offset="100%"></stop>
                </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="50"></circle>
        </svg>
        <svg className="shape-1 d-none d-sm-block" viewBox="0 0 240.83 240.83" xmlns="http://www.w3.org/2000/svg">
            <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03" transform="translate(120.42 -49.88) rotate(45)"></rect>
            <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03" transform="translate(-49.88 120.42) rotate(-45)"></rect>
        </svg>
        <svg className="shape-2 d-none d-sm-block" viewBox="0 0 100 100"
             xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="50"></circle>
        </svg>
        <div className="device-wrapper">
            <div className="device" data-device="iPhoneX" data-orientation="portrait" data-color="black">
                <div className="screen bg-black">
                    <video muted="muted" autoPlay={true} loop={true}
                           style={{maxWidth: '100%', height: '100%'}}
                           src={demoScreen}></video>
                </div>
            </div>
        </div>
    </div>

const Features = () =>
    <section className="features py-5">
        <Container>
            <h2 className="text-center mb-5">Why Poker Ledger?</h2>
            <Row className="g-4">
                <Col md={4}>
                    <div className="feature-card text-center p-4">
                        <BsCalculatorFill className="feature-icon mb-3" />
                        <h3>Track Everything</h3>
                        <p>Monitor buy-ins, cash-outs, and running balances in real-time. Never lose track of the money flow.</p>
                    </div>
                </Col>
                <Col md={4}>
                    <div className="feature-card text-center p-4">
                        <BsPeopleFill className="feature-icon mb-3" />
                        <h3>Manage Players</h3>
                        <p>Create a house roster, track regular players, and easily add them to games. Perfect for recurring game nights.</p>
                    </div>
                </Col>
                <Col md={4}>
                    <div className="feature-card text-center p-4">
                        <BsCreditCardFill className="feature-icon mb-3" />
                        <h3>Payment Flexibility</h3>
                        <p>Support for multiple payment methods including cash, Venmo, Cash App, and PayPal. Track settled and pending payments.</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>

const HowItWorks = () =>
    <section id="how-it-works" className="how-it-works py-5 bg-light">
        <Container>
            <h2 className="text-center mb-5">How It Works</h2>
            <Row className="g-4">
                <Col lg={3}>
                    <div className="step-card">
                        <div className="step-number">1</div>
                        <h4>Create Your House</h4>
                        <p>Sign up and create your poker house to start managing games.</p>
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="step-card">
                        <div className="step-number">2</div>
                        <h4>Add Players</h4>
                        <p>Build your player roster with regular game participants.</p>
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="step-card">
                        <div className="step-number">3</div>
                        <h4>Start a Game</h4>
                        <p>Create a new game and add players from your roster.</p>
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="step-card">
                        <div className="step-number">4</div>
                        <h4>Track Transactions</h4>
                        <p>Record buy-ins and cash-outs as they happen.</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>

const CallToAction = () =>
    <section className="cta-section py-5 text-center">
        <Container>
            <h2 className="mb-4">Ready to Simplify Your Poker Game Management?</h2>
            <p className="lead mb-4">Join other hosts who are already using Poker Ledger to run smoother games.</p>
            <Link to="/sign-up">
                <Button variant="success" size="lg">Get Started For Free</Button>
            </Link>
        </Container>
    </section>

